// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import { deleteProduct, getAllProducts, getProduct, updateProduct } from '../../helpers/backend_helper';
import { fetchProductsFailure, fetchProductsSuccess, openEditPageProductSuccess, updateProductFailure, updateProductSuccess } from './actions';
import { deleteProductFailure, deleteProductSuccess, fetchProductFailure, fetchProductSuccess } from '../actions';
import { DELETE_PRODUCTS_REQUEST, FETCH_PRODUCTS_REQUEST, FETCH_PRODUCT_REQUEST, OPEN_EDIT_PAGE_PRODUCT, UPDATE_PRODUCTS_REQUEST } from './actionTypes';
import { reduxSerializedError } from '../../utils/utils';

function* fetchProductsSaga() {
  try {
    const response = yield call(getAllProducts);

    // Store the mapping in localStorage
    yield put(fetchProductsSuccess(response.data));
  } catch (error) {
    yield put(fetchProductsFailure(reduxSerializedError(error)));
  }
}

function* fetchProductSaga({ payload }) {
  try {
    const response = yield call(getProduct, payload);
    yield put(fetchProductSuccess(response));
  } catch (error) {
    yield put(fetchProductFailure(reduxSerializedError(error)));
  }
}

function* deleteProductsSaga({ payload }) {
  try {
    yield call(deleteProduct, payload);
    yield put(deleteProductSuccess(payload));
    yield call(fetchProductsSaga);
  } catch (error) {
    yield put(deleteProductFailure(reduxSerializedError(error)));
  }
}

function* updateProductSaga({ payload }) {
  const { product, navigate, config } = payload;
  try {
    yield call(updateProduct, product, config);
    yield put(updateProductSuccess());
    navigate("/catalogs");
    yield call(fetchProductsSaga); 
  } catch (error) {
    yield put(updateProductFailure(reduxSerializedError(error)));
  }
}

function* openEditPageProductSaga({ payload }) {
  const { id, navigate } = payload;
  try {
    navigate(`/catalogs/${id}`);
    yield put(openEditPageProductSuccess());
  } catch (error) {
    console.error('Navigation error:', error);
  }
}


export default function* rootSaga() {
  yield takeEvery(FETCH_PRODUCTS_REQUEST, fetchProductsSaga);
  yield takeEvery(FETCH_PRODUCT_REQUEST, fetchProductSaga);
  yield takeEvery(UPDATE_PRODUCTS_REQUEST, updateProductSaga);
  yield takeEvery(DELETE_PRODUCTS_REQUEST, deleteProductsSaga);
  yield takeEvery(OPEN_EDIT_PAGE_PRODUCT, openEditPageProductSaga);
}
